export default __webpack_public_path__ + "static/cafe_36044-544b53718c11cd44db9b8d9438e30213.png";